import { Inject, Injectable } from '@angular/core';
import {
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpResponse,
} from '@angular/common/http';

import { Observable } from 'rxjs';

import { CORE_CONFIGURATION, IConfigurationVM } from '../models';

@Injectable({
  providedIn: 'root',
})
export class GenericApiService {
  constructor(
    private http: HttpClient,
    @Inject(CORE_CONFIGURATION) private configurationVM: IConfigurationVM
  ) { }

  getBaseAPIUrl = (): string => {
    return this.configurationVM.baseApiUrl;
  };

  /** Generic Http get request */
  get<T>(url: string): Observable<HttpResponse<T>> {
    const fullUrl = `${this.configurationVM.baseApiUrl}/${url}`;

    return this.http.get<T>(fullUrl, {
      observe: 'response',
      responseType: 'json',
    });
  }
  SendOtpWithToken<T>(url: string,token:any): Observable<HttpResponse<T>> {
    const fullUrl = `${this.configurationVM.baseApiUrl}/${url}`;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`, // Replace 'this.token' with your actual token variable
    });
    return this.http.get<T>(fullUrl, {
      headers:headers,
      observe: 'response',
      responseType: 'json',
    });
  }

  /** Generic Http delete request */
  delete<T>(url: string): Observable<HttpResponse<T>> {
    const fullUrl = `${this.configurationVM.baseApiUrl}/${url}`;

    return this.http.delete<T>(fullUrl, {
      observe: 'response',
      responseType: 'json',
    });
  }

  /** Generic Http post request */
  post<T>(url: string, body: any): Observable<HttpResponse<T>> {
    const fullUrl = `${this.configurationVM.baseApiUrl}/${url}`;

    return this.http.post<T>(fullUrl, body, {
      observe: 'response',
      responseType: 'json',
    });
  }

  /** Generic Http put request */
  put<T>(url: string, body: any): Observable<HttpResponse<T>> {
    const fullUrl = `${this.configurationVM.baseApiUrl}/${url}`;

    return this.http.put<T>(fullUrl, body, {
      observe: 'response',
      responseType: 'json',
    });
  }

  uploadFile<T>(url: string, formData: FormData): Observable<HttpEvent<T>> {
    const fullUrl = `${this.configurationVM.baseApiUrl}/${url}`;

    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'multipart/form-data');

    return this.http.post<T>(fullUrl, formData, {
      reportProgress: true,
      observe: 'events',
      responseType: 'json',
      headers: headers,
    });
  }

  uploadImage<T>(url: string, formData: FormData): Observable<T> {
    const fullUrl = `${this.configurationVM.baseApiUrl}/${url}`;

    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'multipart/form-data');

    return this.http.post<T>(fullUrl, formData, {
      responseType: 'json',
      headers: headers,
    });
  }

  getConfiguration = (): IConfigurationVM => {
    return this.configurationVM;
  }

  /** Generic Http get request */
  getDirect(url: string) {
    return this.http.get(url, { observe: 'body', responseType: 'blob' });
  }
}
